import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNewTag, postCreateBusinessTag } from "apis";
import { getQueueConfigQueryKey } from "./get-queue-config";
import { QueueConfigData } from "./types";

export function useCreateTagMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postCreateBusinessTag,
    onSuccess: () => queryClient.invalidateQueries(getQueueConfigQueryKey()),
    onSettled: async (data, _, variables) => {
      if (data) {
        const { success, data: newTagRecord } = data;
        if (success && newTagRecord) {
          const { businessId } = variables;
          queryClient.setQueryData<QueueConfigData>(
            getQueueConfigQueryKey({ businessId }),
            (old) => {
              if (!old) {
                return {
                  tags: [newTagRecord],
                  sku_items: [],
                  user_preferences: {},
                  followup_reminders: [],
                  receipt_counter: [],
                  restrictions: {
                    is_edit_receipt_restricted: false,
                    is_start_visit_restricted: false,
                  },
                } as QueueConfigData;
              }

              const updatedConfig: QueueConfigData = {
                ...old,
              };

              if (!updatedConfig.tags) {
                updatedConfig.tags = [];
              }

              updatedConfig.tags = [...updatedConfig.tags, newTagRecord];
              return updatedConfig;
            }
          );
        }
      }
    },
  });
}
